import { loadTrackId, loadToken, loadPromoter, loadLocale } from '../utils/cache'
import sha256 from 'js-sha256'

//refactor: 增加adminlogin单独处理逻辑，一次性进行验证和角色授权处理（包括菜单）
export default {
	refreshCaptcha(cb, ecb) {
		var trackId = loadTrackId()
		this.http
			.get('/captcha/refresh/' + trackId + '/?o=' + Math.random(), {})
			.then((r) => cb && cb(r))
			.catch((e) => ecb && ecb(e))
	},
	sendCode(mobile, captchainput, cb, ecb) {
		let trackId = loadTrackId()
		this.http
			.post('/user/sendMobileLoginCode/', {
				mobile: mobile,
				captchainput: captchainput,
				sessionId: trackId
			})
			.then((r) => cb && cb(r))
			.catch((e) => ecb && ecb(e))
	},
	sendSMSCode(type, mobile, captchainput, cb, ecb, config = {}) {
		let trackId = loadTrackId()
		this.http
			.post(
				'/user/sendSMSCode/',
				{
					type: type,
					mobile: mobile,
					captchainput: captchainput,
					sessionId: trackId
				},
				config
			)
			.then((r) => cb && cb(r))
			.catch((e) => ecb && ecb(e))
	},
	sendBindCode(mobile, cb, ecb, config = {}) {
		let trackId = loadTrackId()
		this.http
			.post(
				'/user/sendBindMobileCode/',
				{
					mobile: mobile,
					sessionId: trackId
				},
				config
			)
			.then((r) => cb && cb(r))
			.catch((e) => ecb && ecb(e))
	},
	bindMobile(form, cb, ecb, config) {
		this.http
			.post('/user/bindMobile/', form, config)
			.then((r) => cb && cb(r))
			.catch((e) => ecb && ecb(e))
	},
	sendBindEmailCode(email, cb, ecb, config = {}) {
		this.http
			.post('/user/sendBindEmailCode/' + email, {}, config)
			.then((r) => cb && cb(r))
			.catch((e) => ecb && ecb(e))
	},
	bindEmail(form, cb, ecb) {
		this.http
			.post('/user/bindEmail/', form)
			.then((r) => cb && cb(r))
			.catch((e) => ecb && ecb(e))
	},
	login(form, cb, ecb, config = {}) {
		//密码登录
		let trackId = loadTrackId()
		this.http
			.post(
				'/auth/login',
				{
					email: form.email,
					password: sha256(form.password),
					captchainput: form.captchainput,
					sessionId: trackId
				},
				config
			)
			.then((r) => cb && cb(r))
			.catch((e) => ecb && ecb(e))
	},
	/** shop SSO：用授权码换取 roast JWT */
	ssoLogin(code, cb, ecb, config = {}) {
		this.http
			.post(
				'/auth/ssologin',
				{ code },
				{
					alertError: false,
					...config
				}
			)
			.then((r) => cb && cb(r))
			.catch((e) => ecb && ecb(e))
	},
	register(form, cb, ecb, config) {
		let locale = loadLocale()
		console.log('locale', locale)
		this.http
			.post('/auth/register', form, config)
			.then((response) => cb && cb(response))
			.catch((e) => ecb && ecb(e))
	},
	mobileLogin(form, cb, ecb, config = {}) {
		form.sessionId = loadTrackId()
		form.pro = loadPromoter() //存在默认注册的情况
		this.http
			.post('/user/mobileAuth/', form, config)
			.then((r) => cb && cb(r))
			.catch((e) => ecb && ecb(e))
	},
	tokenLogin(token, cb, ecb) {
		// let pro = loadPromoter() //不需要处理，这中情况一般已经创建好用户了（完成注册）
		//oatuh登录返回的是token，用token获取userinfo - 微信小程序获得token后，再传给前端来，然后登录前端
		this.http
			.post('/user/tokenAuth/', {
				token: token
			})
			.then((r) => cb && cb(r))
			.catch((e) => ecb && ecb(e))
	},
	oauthLogin(token, cb, ecb) {
		//oatuh登录返回的是token，用token获取userinfo - 微信小程序获得token后，再传给前端来，然后登录前端
		this.http
			.post('/user/tokenAuth/', {
				token: token
			})
			.then((r) => cb && cb(r))
			.catch((e) => ecb && ecb(e))
	},
	wechatCodeLogin(code, cb, ecb) {
		let params = { code }
		let pro = loadPromoter()
		if (pro) params.pro = pro //可能顺便新建用户
		//公众号授权登录，oatuh从微信跳转过来的code直接进行登录，比token方式少一步
		// console.log('wechatCodeLogin', params, code)
		this.http
			.get('/oauth/wechatCodeAuth/', {
				alertError: false, //不要弹出，交给callback处理
				params
			})
			.then((r) => cb && cb(r))
			.catch((e) => ecb && ecb(e))
	},
	/*
	 * APP授权登录
	 * TODO 理论是app也可以通过universal link跳入页面并将promoter存入LS
	 */
	wechatMobileAppCodeLogin(code, cb, ecb) {
		this.http
			.get('/oauth/wechatMobileAppCodeAuth/', {
				alertError: false, //不要弹出，交给callback处理
				params: { code: code }
			})
			.then((r) => cb && cb(r))
			.catch((e) => ecb && ecb(e))
	},
	checkToken() {
		var t = loadToken()
		this.http.get('/user/checkToken/' + t, {}).then((response) => {
			console.log(response)
		})
	},
	findPasswordByMobile(form, cb, ecb, config = {}) {
		let trackId = loadTrackId()
		this.http
			.post(
				'/user/findPasswordByMobile/',
				{
					mobile: form.mobile,
					code: form.code,
					captchainput: form.captchainput,
					sessionId: trackId
				},
				config
			)
			.then((r) => cb && cb(r))
			.catch((e) => ecb && ecb(e))
	},
	findPasswordByEmail(form, cb, ecb, config = {}) {
		let trackId = loadTrackId()
		this.http
			.post(
				'/user/findPasswordByEmail/',
				{
					email: form.email,
					captchainput: form.captchainput,
					sessionId: trackId
				},
				config
			)
			.then((r) => cb && cb(r))
			.catch((e) => ecb && ecb(e))
	},
	validateResetPasswordToken(token, id, cb, ecb, config = {}) {
		let trackId = loadTrackId()
		this.http
			.post('/user/validateResetPasswordToken/' + token + '/' + id, { sessionId: trackId }, config)
			.then((r) => cb && cb(r))
			.catch((e) => ecb && ecb(e))
	},
	resetPassword(form, cb, ecb, config = {}) {
		this.http
			.post('/user/resetPassword', form, config)
			.then((r) => cb && cb(r))
			.catch((e) => ecb && ecb(e))
	},
	getRoleMenu(roleid, cb) {
		this.http.get(`/acl/getRoleMenu/${roleid}`).then((r) => {
			cb(r)
		})
	}
}
